<template>
  <div
    v-if="product"
    :id="`product-${product.Id}-quantity-selector-${product.RowId}`"
    class="d-inline-flex"
    @click.stop="() => {}"
  >
    <v-menu
      v-model="menu"
      :attach="`#product-${product.Id}-quantity-selector-${product.RowId}`"
      :close-on-content-click="false"
      left
      max-height="45"
      origin="right center"
      transition="slide-x-reverse-transition"
    >
      <template #activator="{on, attrs}">
        <v-btn
          class="pa-1"
          color="brand-primary"
          outlined
          style="min-width: 50px; height: 32px;"
          v-bind="attrs"
          v-on="on"
        >
          <div class="d-flex align-center">
            <span class="brand-green-dark--text">{{ vModel }}</span>

            <v-icon small>
              mdi-chevron-down
            </v-icon>
          </div>
        </v-btn>
      </template>

      <div
        class="brand-card-bg rounded d-inline-flex justify-center align-center pa-2"
        style="height: 45px;"
      >
        <v-btn
          class="brand-beige mr-4"
          color="brand-green-dark"
          icon
          small
          @click.stop="onRemoveClick"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>

        <v-btn
          :disabled="vModel <= parseInt(min)"
          class="brand-beige"
          color="brand-green-dark"
          icon
          small
          @click.stop="onDecrementClick"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>

        <div
          ref="quantity"
          class="px-2 brand-green-dark--text brand-text-small font-weight-bold mt-1 text-center text-no-select"
          style="min-width: 44px;"
        >
          <span>{{ quantity }}</span>
        </div>

        <v-btn
          :disabled="vModel === parseInt(max)"
          class="brand-beige"
          color="brand-green-dark"
          icon
          small
          @click.stop="onIncrementClick"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
import ProductCartQuantitySelectorMixin from '@/theme/default/components/product/ProductCartQuantitySelector.js'

export default {
  name  : 'ProductCartQuantitySelector',
  mixins: [ProductCartQuantitySelectorMixin]
}
</script>

<style scoped src="@/theme/default/components/product/ProductCartQuantitySelector.css"></style>

<style scoped>
</style>
